import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.614 4.21A1 1 0 0 0 1 5v14a1 1 0 0 0 1.614.79l9-7A1 1 0 0 0 12 12v7a1 1 0 0 0 1.614.79l9-7a1 1 0 0 0 0-1.58l-9-7A1 1 0 0 0 12 5v7a1 1 0 0 0-.386-.79zM9.37 12 3 16.955v-9.91zm11 0L14 16.955v-9.91z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }